import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASEURL } from '../../constants';
import Avatar from '../common/Avatar';
import { Mail, Phone, Calendar, Home, Package, MapPin, FileText, IdCard } from 'lucide-react';
import StudentChangeRequests from '../StudentChangeRequests';
import { Link } from 'react-router-dom';
import StudentAvatar from '../StudentAvatar';

const UserProfile = () => {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const getdata = async () => {
    setLoading(true);
    try {
      const res = await axios.get(BASEURL + "Student/Address/" + localStorage.getItem("studentId"));
      setData(res.data[0]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getdata();
  }, []);
  const studentName = localStorage.getItem("studentName");
  const initials = `${studentName?.[0] || ''}${studentName?.[1] || ''}`.toUpperCase()
  
  // helper method to build the address
  const buildAddress = (parts) => parts.map((v) => (typeof v === "string" ? v.trim() : v)).filter(Boolean).join(", ");


  const residentialAddress = buildAddress([
    data.localAddressLine1,
    data.localAddressLine2,
    data.localAddressLine3,
    data.localSuburb,
    [data.localState, data.localPostCode].filter(Boolean).join(" "),
    data.localCountry,
  ]);

  const mailingAddress = buildAddress([
    data.mailingAddressLine1,
    data.mailingAddressLine2,
    data.mailingAddressLine3,
    data.mailingSuburb,
    [data.mailingState, data.mailingPostCode].filter(Boolean).join(" "),
    data.mailingCountry,
  ]);

  const avetmissAddress = buildAddress([
    data.propertyName,
    data.flatDetail,
    [data.streetNo, data.streetName].filter(Boolean).join(" "),
    data.avetmissSuburb,
    [data.avetmissState, data.avetmissPostCode].filter(Boolean).join(" "),
    data.avetmissCountry,
  ]);


  return (
    <div className="mt-6">
      <div className='bg-white shadow-md p-6 rounded-md'>

        {/* Profile & Mailing Address Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
          {/* Profile Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex justify-end">
              <Link 
            to="/dashboard/editStudentDetails"
            className="text-sm text-blue-600 hover:text-blue-700 font-medium">
            Edit
            </Link>
            </div>
            <div className="flex items-center gap-4 sm:gap-6 min-w-0">
              
              {/* Avatar */}
              {loading ? (
                <div className="w-20 h-20 rounded-full bg-gray-200 animate-pulse" />
                  ) : (
                    // <Avatar
                      // className="rounded-full w-20 h-20"
                    //   url={`https://ui-avatars.com/api/?name=${data.firstName}&background=random`}
                    // />
                //     <div className="w-20 h-20 bg-blue-50 border-2 border-blue-100 rounded-full flex items-center justify-center">
                //   <span className="text-2xl text-blue-600">{initials}</span>
                // </div>
                <StudentAvatar size={{ base: 56, sm:72 }} textSize={{ base: "1rem", sm: "1.2rem"}}/>
              )}

              {/* Profile Details */}
              <div className="space-y-2">
                {loading ? (
                  <>
                    <div className="h-4 w-40 bg-gray-200 rounded animate-pulse" />
                    <div className="h-3 w-32 bg-gray-200 rounded animate-pulse" />
                    <div className="h-3 w-48 bg-gray-200 rounded animate-pulse" />
                    <div className="h-3 w-28 bg-gray-200 rounded animate-pulse" />
                  </>
                ) : (
                  <>
                    <p className="text-lg font-semibold text-gray-900">
                      {data.firstName} {data.lastName}
                    </p>

                    <div className="flex items-center gap-2 text-gray-600">
                      <IdCard  className="w-4 h-4" />
                      <span className="text-sm" title='Student No'>{localStorage.getItem("studentNo")}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600">
                      <Calendar className="w-4 h-4" />
                      <span className="text-sm" title='DOB'>{data.dob}</span>
                    </div>

                    <div className="flex items-center gap-2 text-gray-600">
                      <Mail className="w-4 h-4" />
                      <span className="text-sm">{data.email}</span>
                    </div>

                    <div className="flex items-center gap-2 text-gray-600">
                      <Phone className="w-4 h-4" />
                      <span className="text-sm">{data.mobile}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            {/* Residential Address */}
            <div className="flex items-center gap-3 pb-1">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                <Home className="w-5 h-5 text-blue-500" />
              </div>
              <h3 className="text-base font-semibold text-gray-900">Residential Address</h3>
            </div>

            <div className="flex-1 py-0.5 pl-[3.2rem] border-b border-gray-100">
              {loading ? (
                <div className="space-y-2">
                  <div className="h-3 w-full bg-gray-200 rounded animate-pulse" />
                  <div className="h-3 w-3/4 bg-gray-200 rounded animate-pulse" />
                </div>
              ) : residentialAddress ? (
                <p className="text-sm text-gray-900 leading-relaxed">{residentialAddress}</p>
              ) : (
                <p className="text-sm text-gray-400 italic leading-relaxed">Not provided</p>
              )}
            </div>

            {/* Mailing Address Card */}
            <div className="flex items-center gap-3 mt-2">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                <Package className="w-5 h-5 text-blue-500" />
              </div>
              <h3 className="text-base font-semibold text-gray-900">Mailing Address</h3>
            </div>

            <div className="flex-1 py-1 pl-[3.2rem] border-b border-gray-100">
              {loading ? (
                <div className="space-y-2">
                  <div className="h-3 w-full bg-gray-200 rounded animate-pulse" />
                  <div className="h-3 w-4/5 bg-gray-200 rounded animate-pulse" />
                </div>
              ) : mailingAddress ? (
                <p className="text-sm text-gray-900 leading-relaxed">{mailingAddress}</p>
              ) : (
                <p className="text-sm text-gray-400 italic leading-relaxed">Not provided</p>
              )}
            </div>

            {/* Avetmiss Address */}
            <div className="flex items-center gap-3 mt-2">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-blue-500" />
              </div>
              <h3 className="text-base font-semibold text-gray-900">Avetmiss Address</h3>
            </div>

            <div className="flex-1 py-1 pl-[3.2rem] border-b border-gray-100">
              {loading ? (
                <div className="space-y-2">
                  <div className="h-3 w-full bg-gray-200 rounded animate-pulse" />
                  <div className="h-3 w-4/5 bg-gray-200 rounded animate-pulse" />
                </div>
              ) : avetmissAddress ? (
                <p className="text-sm text-gray-900 leading-relaxed">{avetmissAddress}</p>
              ) : (
                <p className="text-sm text-gray-400 italic leading-relaxed">Not provided</p>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className='mt-6'>
        {/* Student Change Requests */}
        <StudentChangeRequests />
      </div>
    </div>
  );
};

export default UserProfile;